import { select } from '@angular-redux/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from '@app/core/services';
import { RewardService } from '@app/features/rewards/services/reward.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-points-banner',
  templateUrl: './points-banner.component.html',
  styleUrls: ['./points-banner.component.less']
})
export class PointsBannerComponent implements OnInit, OnDestroy {
  private subscriptions = new Subscription();
  myPoints: any;
  @select((appState) => appState.user.points) userPoints?: Observable<any>;

  constructor(private modalService: ModalService, public rewards: RewardService) { }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit() {
    this.subscriptions.add(this.userPoints.subscribe(userPoints => {
      if(userPoints !== undefined && userPoints !== null) {
        this.myPoints = <number>userPoints;
      } else {
        if (this.rewards?.points == null && this.rewards.points == undefined) {
          this.rewards.getRewardSummary().then(success =>{
            this.myPoints = success.points;
          });
        } else {
          this.myPoints = this.rewards.points;
        }
      }
    }));

  }

  help(){
    this.showModal('app-points-tutorial');
  }
  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }
}
